export default __webpack_public_path__ + "static/media/hero-img1.6b0b139a.jpg";